import { connect } from 'react-redux'
import { compose } from 'redux'
import styled from 'styled-components'
import { toggleAutoPlay } from 'shared/redux/auto-play'
import AnimatedBackground from 'shared/components/animated-background/background'
import * as selectors from 'shared/redux/reducers'
import Grid from 'shared/components/search/grid'
import { AutoPlayHeader } from '../components/header/header'
import withLocationState from 'shared/components/with-location-state'
import NoFavorites from 'shared/components/favorite/no-favorites'

const Background = styled.div`
    height: 100%;
    left: 0;
    opacity: 0.8;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
`

const Favorites = ({ autoPlay, toggleAutoPlay, gifs }) => {
    return gifs.length > 0 ? (
        <div>
            <div>
                <AutoPlayHeader onToggleAutoPlay={toggleAutoPlay} autoPlay={autoPlay} />
                <div style={{ clear: 'both' }} />
            </div>
            <Grid />
        </div>
    ) : (
        <>
            <Background>
                <AnimatedBackground assetUrls={['/static/img/svg/heart.svg']} />
            </Background>
            <NoFavorites />
        </>
    )
}

export default compose(
    connect(
        state => ({
            autoPlay: selectors.getAutoPlay(state),
        }),
        { toggleAutoPlay },
    ),
    withLocationState(['gifs']),
)(Favorites)
